import { HELPDESK } from '../../../shared/constants/workspaces';
import { useOutOfOfficeHours } from '../../../working-hours/hooks/useOutOfOfficeHours';
import { useCurrentUserCapacityLimits } from '../../hooks/useUserLevelCapacityLimits';
import { checkIsNullish } from '../../utils/capacityUtils';
import { CapacityStatus } from './CapacityStatus';
import { OutOfOfficeLabel } from './OutOfOfficeLabel';
import { PortalCapacityStatus } from './PortalCapacityStatus';
import { jsx as _jsx } from "react/jsx-runtime";
export const StatusMessage = ({
  agentId,
  awayMode,
  portalCapacityLimit,
  portalCapacityLoad,
  workspace
}) => {
  const {
    currentSegment,
    isLoadingOOOHours
  } = useOutOfOfficeHours(agentId, {
    isViewingSelf: true
  });
  const {
    capacity,
    loading: isLoadingCapacity
  } = useCurrentUserCapacityLimits();
  if (isLoadingOOOHours || isLoadingCapacity) {
    return null;
  }
  if (currentSegment) {
    return /*#__PURE__*/_jsx(OutOfOfficeLabel, {
      userId: agentId,
      currentSegment: currentSegment
    });
  }
  if (workspace !== HELPDESK &&
  // portalCapacityLimit and portalCapacityLoad are only used for PortalCapacityStatus,
  // and only defined in Inbox
  !checkIsNullish(portalCapacityLoad) && !checkIsNullish(portalCapacityLimit)) {
    return /*#__PURE__*/_jsx(PortalCapacityStatus, {
      portalCapacityLimit: portalCapacityLimit,
      portalCapacityLoad: portalCapacityLoad
    });
  } else if (workspace === HELPDESK && !awayMode && capacity) {
    return /*#__PURE__*/_jsx(CapacityStatus, {
      userCapacity: capacity
    });
  }
  return null;
};
StatusMessage.displayName = 'StatusMessage';